import React from 'react';

import styled from 'styled-components';

// import StyleVariables from '@components/Gui/StyleVariables.js';

const CenteredBlockDiv = styled.div`
    margin-top: 25%;

    &.nw-centeredblock-fullpage {
        margin-top: 0;
        height: calc(100vh - ${(props) => props.$headerHeight}px);
    }

    display: flex;

    .nw-centeredblock-content {
        padding: 0 0.9375rem;
        display: flex;
        flex-flow: column;
        margin: auto;
        align-items: center;
        text-align: center;
    }
`;

const CenteredBlock = ({ children, fullpage = false, headerHeight = 60 }) => {
    return (
        <CenteredBlockDiv className={fullpage && 'nw-centeredblock-fullpage'} $headerHeight={headerHeight}>
            <div className="nw-centeredblock-content">{children}</div>
        </CenteredBlockDiv>
    );
};

export default CenteredBlock;
